import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import UpworkPrepareProposal from './UpworkPrepareProposal';
import { ProposalDetails } from './ProposalDetails';
export default function ProposalWithUpworkReview() {
  const { id } = useParams();
  const [revision, setRevision] = useState(0);
  return <>
    <UpworkPrepareProposal onChanged={() => setRevision((value) => value + 1)} />
    <ProposalDetails key={`${id}:${revision}`} />
  </>;
}
